/**
 * Het merkteken van het testthema.
 *
 * Zet één keer per bezoek `_cl_variant = pdp-v2` op het winkelmandje. De
 * bundelkorting-function kijkt daarnaar: staat het er niet, dan geeft hij geen
 * korting. Het live theme laadt dit bestand niet, dus daar komt het merkteken
 * nooit op het mandje en bestaat de korting niet.
 *
 * Waarom dit nodig is: een korting hoort in Shopify bij de wínkel en niet bij
 * een theme. Zonder zo'n merkteken zou iedereen die twee van hetzelfde artikel
 * in zijn mandje legt de korting krijgen, ook op live. Gemeten over 2500
 * bestellingen sinds 1 februari 2026 zou dat negen bestellingen hebben geraakt
 * — klein, maar niet wat er is afgesproken.
 *
 * WAAROM /cart/update.js EN NIET BIJ HET TOEVOEGEN
 * Alleen `/cart/update.js` met een `attributes`-object staat in de documentatie.
 * `/cart/add.js` accepteert die misschien ook, maar dat staat er niet, en op een
 * ongedocumenteerde route bouwen betekent dat de korting stil verdwijnt zodra
 * Shopify iets wijzigt. Bovendien zijn er drie plekken waar iets in het mandje
 * belandt (de koopknop, de snelkoop-lade en de plusjes van het look-blok), en
 * één merkteken per bezoek dekt ze alle drie.
 *
 * WAAROM DRIE POGINGEN EN EEN LOSSE CONTROLE
 * Bij het doormeten van de zes markten miste het merkteken één keer op ongeveer
 * veertig paginaweergaven. De gevolgen zijn niet incidenteel: de pakketkiezer
 * belóóft dan 10 % die de kassa niet geeft, en dat blijft het hele bezoek zo,
 * want de vlag zou anders zeggen dat het al gelukt was.
 *
 * De oorzaak is niet een mislukt verzoek maar een race om het mandje. Bij de
 * éérste paginaweergave van een bezoek is er nog geen mandje-cookie. Dit script
 * en een tracking-app schrijven dan allebei naar /cart/update.js; komen die
 * tegelijk aan, dan maakt Shopify twee mandjes en wint één cookie. Ons merkteken
 * staat dan op het mandje dat verloor. Nagemeten: het antwoord op ónze aanvraag
 * bevatte het attribuut netjes, en /cart.js een tel later niet meer.
 *
 * Daarom controleert dit script niet zijn eigen antwoord maar leest het daarna
 * /cart.js — dat volgt de cookie die gewonnen heeft. Staat het merkteken daar,
 * dan pas gaat de vlag om. Anders volgt er nog een poging, en anders probeert
 * de volgende paginaweergave het gewoon opnieuw.
 *
 * Eén keer per bezoek en niet bij elke paginaweergave: het attribuut blijft op
 * het mandje staan, dus vaker zetten voegt niets toe en kost alleen verzoeken.
 * De vlag staat in sessionStorage, dus een nieuw tabblad zet hem gewoon opnieuw.
 *
 * Faalt ook de laatste poging, dan gebeurt er niets bijzonders: geen merkteken
 * betekent geen korting. Dat is de goede kant om te falen — nooit korting geven
 * die niet beloofd is.
 */
(function () {
  'use strict';

  var WAARDE = 'pdp-v2';
  var VLAG = 'cl-merkteken-gezet';
  var POGINGEN = 3;

  try {
    if (sessionStorage.getItem(VLAG) === WAARDE) return;
  } catch (e) {
    // Geen sessionStorage (privémodus): dan zetten we hem per pagina. Hinderlijk
    // noch schadelijk, alleen een verzoek meer.
  }

  // Eerst de terugval, dán pas de slash erachter: `false.replace()` bestaat niet.
  var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var wortel = basis.replace(/\/*$/, '/');

  function nogEens(poging) {
    // Oplopend wachten. De eerste herhaling is bewust ruim: bij de race hierboven
    // moet de mandje-cookie eerst tot rust komen, anders schrijven we opnieuw
    // naar het verkeerde mandje.
    if (poging < POGINGEN) setTimeout(function () { zet(poging + 1); }, poging * 900);
  }

  function zet(poging) {
    fetch(wortel + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _cl_variant: WAARDE } }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        // Losse controle: niet het eigen antwoord lezen maar het mandje opnieuw
        // opvragen, want alleen dát volgt de cookie die de race gewonnen heeft.
        return fetch(wortel + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (mandje) {
        if (!mandje || !mandje.attributes || mandje.attributes._cl_variant !== WAARDE) {
          throw new Error('merkteken staat niet op het mandje dat telt');
        }
        try { sessionStorage.setItem(VLAG, WAARDE); } catch (e) {}
      })
      .catch(function () { nogEens(poging); });
  }

  zet(1);
})();
